import { gsap } from "gsap";    
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import pageHandler from './pageHandler';
import { mainNav } from "./main-navigation";
import device from "current-device";

gsap.registerPlugin(ScrollTrigger,SplitText);

pageHandler();
mainNav();